import {
  TextField,
  UrlField,
  ToggleField,
  DateField,
  PhoneField,
  TextAreaField,
} from '../models';

const Operacional = [
  new PhoneField({
    kWord: 'contactPhone',
    label: 'Telefone para contato',
  }),
  new UrlField({
    kWord: 'contactEmail',
    label: 'E-mail para contato',
    email: true,
  }),
  new TextField({
    kWord: 'contactName',
    label: 'Nome do contato',
  }),
  new ToggleField({
    kWord: 'training',
    label: 'Treinamento realizado?',
  }),
  new DateField({
    kWord: 'trainingDate',
    label: 'Data do treinamento',
  }),
  new TextField({
    kWord: 'trainingResponsible',
    label: 'Responsável pelo treinamento',
  }),
  new TextAreaField({
    kWord: 'obs',
    label: 'Observações',
  }),
];

export default Operacional;
